var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box is-centered wrapper-detail-sale-note" },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "columns is-multiline" },
        [
          _c("div", { staticClass: "columns is-multiline" }, [
            _c("div", {
              staticClass: "column",
              class: { "is-12": !_vm.inline, "is-5": _vm.inline }
            })
          ]),
          _c(
            "div",
            {
              staticClass: "column",
              class: { "is-12": !_vm.inline, "is-5": _vm.inline }
            },
            [
              _c("CustomerSearcherByEmail", {
                ref: "inputEmail",
                attrs: {
                  id: "email",
                  name: "email",
                  value: _vm.email,
                  disabled: _vm.isLoading || _vm.disabled,
                  required: true
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "column",
              class: { "is-12": !_vm.inline, "is-5": _vm.inline }
            },
            [
              _c("AppSelectField", {
                attrs: {
                  id: "voucherPaymentMethod",
                  name: "voucherPaymentMethod",
                  label: "Método de pago",
                  value: _vm.voucherPaymentMethod,
                  options: _vm.paymentMethodCatalog
                },
                on: { input: _vm.onChange, change: _vm.onChange }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "column",
              class: { "is-12": !_vm.inline, "is-5": _vm.inline }
            },
            [
              _c("AppInputField", {
                attrs: {
                  id: "name",
                  name: "name",
                  label: "Nombre del cliente:",
                  placeholder: "Fulanito de Tal",
                  value: _vm.name,
                  disabled: _vm.isLoading || _vm.disabled,
                  required: true
                },
                on: {
                  input: _vm.onChangeCustomer,
                  change: _vm.onChangeCustomer
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "column",
              class: { "is-12": !_vm.inline, "is-5": _vm.inline }
            },
            [
              _c("AppSelectSearch", {
                attrs: {
                  id: "voucherPaymentType",
                  name: "voucherPaymentType",
                  label: "Forma de pago:",
                  placeholder: "Selecciona la forma de pago",
                  options: _vm.paymentTypeCatalog,
                  value: _vm.paymentTypeSelectedValue,
                  disabled: _vm.disabled
                },
                on: { input: _vm.onChange, change: _vm.onChange }
              })
            ],
            1
          ),
          _vm.voucherPaymentMethod === "PPD"
            ? [
                _c(
                  "div",
                  {
                    staticClass: "column",
                    class: { "is-12": !_vm.inline, "is-5": _vm.inline }
                  },
                  [
                    _c("AppInputField", {
                      attrs: {
                        label: "Deuda inicial",
                        name: "balance",
                        placeholder: "10",
                        min: "0.000001",
                        step: "0.000001",
                        type: "number",
                        disabled: _vm.isLoading || _vm.disabled,
                        value: _vm.balance,
                        required: ""
                      },
                      on: { input: _vm.onChange, change: _vm.onChange }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "column",
                    class: { "is-12": !_vm.inline, "is-5": _vm.inline }
                  },
                  [
                    _c(
                      "BField",
                      {
                        attrs: {
                          label: "Fecha de vencimiento",
                          "label-for": "expirationDate"
                        }
                      },
                      [
                        _c(
                          "BDatepicker",
                          _vm._b(
                            {
                              attrs: {
                                id: "expirationDate",
                                value: _vm.expirationDate,
                                "date-parser": _vm.dateParser,
                                icon: "calendar-today"
                              },
                              on: {
                                input: function($event) {
                                  return _vm.onChangeExpiration(
                                    "expirationDate",
                                    $event
                                  )
                                },
                                change: function($event) {
                                  return _vm.onChangeExpiration(
                                    "expirationDate",
                                    $event
                                  )
                                }
                              }
                            },
                            "BDatepicker",
                            _vm.calendarProps,
                            false
                          )
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.advanced,
                  expression: "advanced"
                }
              ],
              staticClass: "column",
              class: { "is-12": !_vm.inline, "is-4": _vm.inline }
            },
            [
              _c("AppInputField", {
                attrs: {
                  id: "voucherDate",
                  name: "voucherDate",
                  label: "Fecha y hora de expedición*:",
                  type: "dateTime-local",
                  value: _vm.voucherDateToInput,
                  disabled: _vm.isLoading || _vm.disabled,
                  min: _vm.minDateTime,
                  max: _vm.maxDateTime,
                  "left-icon": "date_range"
                },
                on: { input: _vm.onChange, change: _vm.onChange }
              })
            ],
            1
          ),
          _vm.advanced
            ? [
                _c(
                  "div",
                  {
                    staticClass: "column",
                    class: { "is-12": !_vm.inline, "is-4": _vm.inline }
                  },
                  [
                    _c("AppInputField", {
                      attrs: {
                        id: "voucherExpeditionPlace",
                        name: "voucherExpeditionPlace",
                        label: "Código postal*:",
                        placeholder: "02719",
                        value: _vm.voucherExpeditionPlace,
                        disabled: _vm.isLoading || _vm.disabled,
                        required: true
                      },
                      on: { input: _vm.onChange, change: _vm.onChange }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "column",
                    class: { "is-12": !_vm.inline, "is-5": _vm.inline }
                  },
                  [
                    _c("AppSelectSearch", {
                      attrs: {
                        id: "voucherCurrency",
                        name: "voucherCurrency",
                        label: "Moneda*:",
                        placeholder: "Selecciona una moneda",
                        options: _vm.currencyCatalog,
                        value: _vm.currencySelectedValue,
                        disabled: _vm.isLoading || _vm.disabled
                      },
                      on: {
                        input: _vm.onChangeCurrency,
                        change: _vm.onChangeCurrency
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "column",
                    class: { "is-12": !_vm.inline, "is-5": _vm.inline }
                  },
                  [
                    _c("AppInputRfc", {
                      attrs: {
                        id: "receiverRfc",
                        name: "receiverRfc",
                        "valid-icon": false,
                        value: "XAXX010101000",
                        disabled: _vm.disabled,
                        "is-loading": _vm.isLoading,
                        required: true
                      },
                      on: { input: _vm.onChange, change: _vm.onChange }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "column",
                    class: { "is-12": !_vm.inline, "is-4": _vm.inline }
                  },
                  [
                    _c("AppInputField", {
                      attrs: {
                        id: "receiverName",
                        name: "receiverName",
                        label: "Nombre o razón social:",
                        placeholder: "Nombre o razón social",
                        value: "Venta al público en general",
                        disabled: _vm.disabled,
                        "is-loading": _vm.isLoading,
                        required: true
                      },
                      on: { input: _vm.onChange, change: _vm.onChange }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.otherCurrency,
                        expression: "otherCurrency"
                      }
                    ],
                    staticClass: "column",
                    class: { "is-12": !_vm.inline, "is-4": _vm.inline }
                  },
                  [
                    _c("AppInputField", {
                      attrs: {
                        id: "voucherExchangeRate",
                        name: "voucherExchangeRate",
                        label: "Tipo de cambio:",
                        placeholder: "0.00",
                        value: _vm.voucherExchangeRate,
                        disabled: _vm.isLoading || _vm.disabled
                      },
                      on: { input: _vm.onChange, change: _vm.onChange }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "column",
                    class: { "is-12": !_vm.inline, "is-4": _vm.inline }
                  },
                  [
                    _c("AppSelectField", {
                      attrs: {
                        id: "voucherPaymentMethod",
                        name: "voucherPaymentMethod",
                        label: "Metodo de pago:",
                        options: _vm.paymentMethodCatalog,
                        value: _vm.voucherPaymentMethod,
                        disabled: _vm.isLoading || _vm.disabled
                      },
                      on: { input: _vm.onChange, change: _vm.onChange }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "column",
                    class: { "is-12": !_vm.inline, "is-4": _vm.inline }
                  },
                  [
                    _c("AppSelectField", {
                      attrs: {
                        id: "voucherType",
                        name: "voucherType",
                        label: "Tipo de comprobante:",
                        options: _vm.voucherTypeCatalog,
                        value: _vm.voucherType,
                        disabled: ""
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "column is-6-mobile is-3" },
                  [
                    _c("AppInputField", {
                      attrs: {
                        id: "voucherSeries",
                        name: "voucherSeries",
                        label: "Serie:",
                        value: _vm.voucherSeries,
                        disabled: _vm.isLoading || _vm.disabled
                      },
                      on: { input: _vm.onChange, change: _vm.onChange }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "column is-6-mobile is-4" },
                  [
                    _c("AppInputField", {
                      attrs: {
                        id: "voucherConsecutive",
                        name: "voucherConsecutive",
                        label: "Folio:",
                        type: "number",
                        min: "1",
                        value: _vm.voucherConsecutive,
                        disabled: _vm.isLoading || _vm.disabled
                      },
                      on: { input: _vm.onChange, change: _vm.onChange }
                    })
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-container is-flex" }, [
      _c(
        "h1",
        {
          staticClass:
            "title is-centered is-4 has-text-primary title-detail-sale-note"
        },
        [_vm._v("\n      Detalle Nota de Remisión\n    ")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }